import * as React from "react";
const SvgInfoFilled24 = (props, ref) => React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { fill: "currentColor", d: "M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12Zm11.5-4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM12 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Z" }));
const ForwardRef = React.forwardRef(SvgInfoFilled24);
export default ForwardRef;
